export const checkMimeType = (files: string | any[], fileTypes: any) => {
    const types = fileTypes;
    for (let x = 0; x < files.length; x++) {
        if (types.every((type: any) => files[x].type !== type)) {
            const name = files[x].name;
            return { isValid: false, fileName: name }
        }
    }
    return { isValid: true, fileName: null };
};

export const maxSelectFile = (files: any[], maxNumFiles: number) => {
    const length = files.length;
    if (length > maxNumFiles) {
        let removedFileNames: any[] = [];
        files.map(item => {
            removedFileNames.push(item.name);
        });
        return { isValid: false, filesLength: length, removedFiles: removedFileNames.slice(maxNumFiles) };
    }
    return { isValid: true, filesLength: 0, removedFiles: [] };
};

export const checkFileSize = (files: string | any[], fileSize: any) => {
    let size = fileSize;
    for (let x = 0; x < files.length; x++) {
        if (files[x].size > size) {
            const name = files[x].name;
            return { isValid: false, fileName: name, Size: size };
        }
    }
    return { isValid: true, fileName: null, Size: 0 };
};